import {formatDateTime, random, round2} from "../helpers/helpers";


export const generate_pump_vibration_block = () => ({
    acceleration_axis1: round2(random(0.02, 1.2)),
    acceleration_axis2: round2(random(0.02, 1.2)),
    acceleration_axis3: round2(random(0.02, 1.2)),
    velocity_axis1: round2(random(0.02, 1.5)),
    velocity_axis2: round2(random(0.02, 1.5)),
    velocity_axis3: round2(random(0.02, 1.5)),
    temperature: round2(random(30, 55)),
    last_sync_time: formatDateTime(new Date()),
});